import React from 'react';
import { useNavigate } from 'react-router-dom';

const ErrorPage = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1); // Go back to the previous page
    };

    return (
        <div style={{ textAlign: 'center', padding: '50px', backgroundColor: '#f8d7da', color: '#721c24', height: '100vh' }}>
            <h1 style={{ fontSize: '2rem' }}>Oops! Something went wrong.</h1>
            <p style={{ fontSize: '1.2rem' }}>An error has occurred. Please try again later or go back to the previous page.</p>
            <button
                onClick={handleGoBack}
                style={{
                    marginTop: '20px',
                    padding: '10px 20px',
                    fontSize: '1rem',
                    color: '#fff',
                    backgroundColor: '#721c24',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer'
                }}
            >
                Go Back
            </button>
        </div>
    );
};

export default ErrorPage;
